import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import {
    ButtonComponent,
    ContainerComponent,
    HeadingComponent,
    IDynamicElement,
    ILink,
    ISocialMediaItem,
    LinkDirective,
    MediaImage,
    TextHtmlComponent,
} from '@sirius/common';
import { HighlightedItemWithLink, IInfoOverview } from 'shared/models';
import { CommonModule } from '@angular/common';
import { SocialMediaLinksComponent } from '../social-media-links/social-media-links.component';
import { HighlightComponent } from '../highlight/highlight.component';
import { HighlightItemComponent } from '../highlight/highlight-item.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ur-info-overview',
    templateUrl: './info-overview.component.html',
    styleUrl: './info-overview.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        HighlightComponent,
        HighlightItemComponent,
        SocialMediaLinksComponent,
        TranslateModule,
        ContainerComponent,
        ButtonComponent,
        HeadingComponent,
        LinkDirective,
        TextHtmlComponent,
    ],
})
export class InfoOverviewComponent implements OnInit, IDynamicElement {
    translateService = inject(TranslateService);

    @Input() title = '';
    @Input() description: string | null = '';
    @Input() logo?: MediaImage | null = null; // TODO: fix this
    @Input() highlights: HighlightedItemWithLink[] = [];
    @Input() socialMediaLinks: ISocialMediaItem[] = [];
    @Input() socialMediaTitle?: string;
    @Input() textHighlightTitle?: string;
    @Input() location?: string;
    @Input() country?: string;
    @Input() city?: string;
    @Input() street?: string;
    @Input() languages: string[] = [];
    @Input() eventDateTime?: string;
    @Input() formLink?: ILink;
    @Input() config?: IInfoOverview;

    async ngOnInit() {
        if (this.config) {
            this.title = this.config.title;
            this.textHighlightTitle = this.config.textHighlightTitle;
            this.description = this.config.description ?? '';
            this.socialMediaLinks = this.config.socialMediaLinks ?? [];
            this.location = this.config.location;
            this.city = this.config.city;
            this.street = this.config.street;
            this.country = this.config.country;
            this.languages = this.config.languages ?? [];
            this.eventDateTime = this.config.eventDateTime;

            this.translateService.get('page.event.share').subscribe((translatedTitle) => {
                this.socialMediaTitle = translatedTitle;
            });
        }
    }
}
